export type UserSidebarIconSize = 'default' | 'large';
